import React from 'react'
import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'


import Recherche from 'EurestoComponents/Recherche'

import Search from '../Search'
import moment from 'moment'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid/Grid'
import EmojiEuresto from 'Components/Emoji'

import h2p from 'html2plaintext'

moment.locale('fr')

class DatagridContact extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const columns = [
      { Header: 'id', accessor: 'id', show: false },
      {
        Header: '',
        minWidth: 30,
        accessor: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
          justify={'flex-start'}>{(d.flags || []).map(flag => <EmojiEuresto flag={flag} />)}
        </Grid>,
        filterable: false,
        id: 'flags',
        sortable: false
      },
      {
        Header: <span>{EurestoI18n.t('commun:Date')}</span>,
        accessor: 'date_modification',
        filterable: false,
        width: 100,
        id: 'date_modification',
        Cell: (row) => <span style={{
          color: row.original.importance === 0 && EurestoColor('EurestoPrimary') || row.original.importance === 1 && EurestoColor('EurestoError') || EurestoColor('disabled', '')
        }}>{moment(row.original.date_modification).format('DD/MM/YY HH:mm')}</span>
      },
      {
        Header: <span style={{ float: 'left' }}>{EurestoI18n.t('commun:Classeur/Dossier/Ticket')}</span>,
        filterable: false,
        sortable: false,
        minWidth: 200,
        Cell: (row) => {
          const classeur = Data.get(Constants.module.SDD, Constants.donnee.classeur, { id: row.original.classeur_id })
          const libelleMainClasseur = (classeur.classeur_id === null && classeur.libelle || Data.get(Constants.module.SDD, Constants.donnee.classeur, { id: classeur.classeur_id }).libelle)
          const libelleSubClasseur = classeur.classeur_id === null ? '' : classeur.libelle

          return <span style={{ float: 'left' }}>
            <b className={row.original.status === 0 && 'EurestoError--text' || 'EurestoPrimary--text'}>{row.original.libelle || ''}</b>
            <b className={'EurestoError--text'}>{row.original.libelle && ' ( ' || ''}</b>
            <b className={'EurestoSecondary--text'}>{libelleMainClasseur}</b><b
              className={'EurestoError--text'}>{libelleSubClasseur && ' / ' || ''}</b>
            <b className={'EurestoSecondary--text'}>{libelleSubClasseur}</b>
            <b className={'EurestoError--text'}>{row.original.libelle && ' ) ' || ''}</b>
          </span>
        }
      },
      {
        Header: <span>{EurestoI18n.t('commun:Message')}</span>,
        sortable: false,
        accessor: d => <Tooltip disableTouchListener placement="bottom-start" title={
          <div
            style={{
              fontSize: 15,
              padding: 5,
              paddingLeft: 10,
              paddingRight: 10,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: '-moz-pre-wrap',
              //wordBreak: 'break-all',
              overflowWrap: 'break-word',
              textAlign: 'left',
              //lineHeight: '15px',
            }} dangerouslySetInnerHTML={{ __html: d.message.replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>') }} />
        }>
          <span style={{ float: 'left' }}>{h2p(d.message)}</span>
        </Tooltip>,
        id: 'message',
        filterable: false
      },
      {
        id: 'contact_libelle',
        minWidth: 200,
        accessor: 'contact_libelle',
        Header: <span>{EurestoI18n.t('commun:Tiers')}</span>,
        filterable: false,
        Cell: (row) => {
          return <span>{row.original.contact_libelle}</span>
        },
      },
      {
        id: 'user_libelle',
        accessor: 'user_libelle',
        Header: <span>{EurestoI18n.t('commun:Par')}</span>,
        filterable: false,
        width: 120,
        Cell: (row) => {
          return <span>{row.original.user_libelle}</span>
        }
      },
      {
        id: 'user_assign_libelle',
        accessor: 'user_assign_libelle',
        Header: <span>{EurestoI18n.t('commun:Assigné à')}</span>,
        filterable: false,
        width: 120,
        Cell: (row) => {
          return <span
            className={row.original.etat && 'EurestoPrimary--text' || 'EurestoError--text'}>{row.original.user_assign_libelle}</span>
        }
      },

      {
        Header: <span>{EurestoI18n.t('commun:Date d\'intervention')}</span>,
        accessor: 'date_intervention',
        filterable: false,
        width: 120,
        id: 'date_intervention',
        Cell: (row) => row.original.date_intervention &&
          <span>{moment(row.original.date_intervention, 'YYYY-MM-DD').format('DD/MM/YY')}</span> || ''
      },

    ]
    return (
      <Recherche
        showSearch={this.props.showSearch}
        searchComponent={<Search defaultSearch={this.props.defaultSearch}
          search={this.props.search || 'dossier_' + (this.props.name || '') + User.Entite.get().id} />}
        view={'list'}
        data={this.props.data}
        type={this.props.type}
        style={this.props.style}
        onClick={this.props.onClick}
        columns={columns}
        search={this.props.search || 'dossier_' + (this.props.name || '') + User.Entite.get().id}
      />
    )
  }

}

export default DatagridContact



// WEBPACK FOOTER //
// ./app/App/Module/SDD/Component/Datagrid/index.js